import { QuizDirective } from "../quiz/quiz.directive";
import {
	Component,
	OnInit,
	OnChanges,
	Input,
	Output,
	ElementRef,
	EventEmitter,
	ViewChild,
} from "@angular/core";
import { tick } from "@angular/core/testing";

@Component({
	selector: "app-vector-quiz",
	templateUrl: "./vector-quiz.directive.html",
	styleUrls: ["./vector-quiz.directive.scss"],
})
export class VectorQuizDirective extends QuizDirective {
	@Input() ShowExpertBtn?: boolean;
	@Input() ExpertBtnlabel: string;
	@Input() expertBtnDisabled: boolean;
	@Input() submitBtnDisabled?: boolean;
	@Input() SubmitBtnClass?: string;
	@Input() textDirection: string;
	@Input() textAlign: string;

	@Output() expertBtnClick?: EventEmitter<any> = new EventEmitter<any>();

	public choiceSelectedHandler(event) {
		console.log("Vector QuizDirective   :", event);
		this.submitBtnDisabled = event.status == "selected" ? false : true;
	}
	public submitButtonClickhandler() {
		this.attempts++;
		let bCorrect: Boolean = true;
		let bSelected: boolean = false;
		const selectedOptions: Array<any> = this.quizOptions.find(
			(option) => option.selected === true
		);
		if (selectedOptions === undefined || selectedOptions.length === 0) {
			// if no options are not selected
			this.quizResult.emit({ result: "noselection" });
			return;
		}
		this.submitBtnDisabled = true;
		for (let item of this.quizOptions) {
			if (item.correct !== item.selected) {
				bCorrect = false;
				break;
			}
		}
		if (bCorrect) {
			this.bshowQuiz = true;
			this.quizResult.emit({
				result: "correct",
				selectedOptions: selectedOptions,
			});
		} else {
			this.quizResult.emit({
				result: "incorrect",
				selectedOptions: selectedOptions,
			});
		}

		if (this.showResult) {
			this.bshowQuiz = false;
			for (let item of this.quizOptions) {
				if (item.correct && item.selected) {
					item.showResult = true;
					item.backgroundColor = "#2BA86C";
					item.fontColor = "#000000";
				} else if (item.correct && !item.selected) {
					item.backgroundColor = "#F5F599";
					item.fontColor = "#000000";
				} else if (!item.correct && item.selected) {
					item.showResult = true;
					item.backgroundColor = "";
				}
				item.disabled = true;
			}
		}
	}
	public expertButtonClickhandler() {
		this.expertBtnClick.emit("expert_btn_click");
	}
}
